import { useModal } from 'react-hooks-use-modal';
import { useAuth } from '../../hooks/useAuth';
import { useModalEffect } from '../../hooks/useModalEffect';
import { useSimpleSnackbar } from '../../hooks/useSimpleSnackbar';
import { UserVideo } from '../../types/http/userVideoResponse';
import { DeleteModalProps } from '../../types/modalProps';
import '../../styles/modal.css';
import { UserVideoIDType } from '../../types/http/userVideoRequest';
import { execRequest } from '../../service/request';
import { API } from '../../const/api';

export const DeleteUserVideoModal: React.FC<DeleteModalProps<UserVideo>> = (props) => {
  const { isOpenModal, setIsOpenModal, mutate, target } = props;
  const [Modal, open, close, isOpen] = useModal('root', {
    preventScroll: true,
  });

  const [auth] = useAuth();
  const pushSnackbar = useSimpleSnackbar();

  useModalEffect(isOpenModal, setIsOpenModal, open, close, isOpen);

  const clickDelete = async () => {
    const body: UserVideoIDType = {
      user_video_id: target.id,
    };

    const result = await execRequest(API.VIDEO_USER_DELETE, {
      token: auth.token,
      email: auth.email,
      method: 'POST',
      body: body,
    });

    if (!result.ok) {
      pushSnackbar('error', `ユーザー動画の削除に失敗しました:${result.error_message}`);
      return;
    }

    if (mutate) {
      mutate();
    }

    pushSnackbar('success', 'ユーザー動画の削除に成功しました');
    close();
  };

  return (
    <Modal>
      <div className="modal-wrapper">
        <h4 className="text-primary">ユーザー動画の削除</h4>
        <div className="d-flex justify-content-between">
          <button className="btn btn-secondary" onClick={close}>
            キャンセル
          </button>
          <button className="btn btn-danger" onClick={clickDelete}>
            削除
          </button>
        </div>
      </div>
    </Modal>
  );
};
